export async function manageWarmupData(callback, key, flowAPI, _temp) {
  let {
    onClientFetch
  } = _temp === void 0 ? {} : _temp;
  const isSSR = flowAPI.environment.isSSR;
  const compId = flowAPI.controllerConfig.compId;
  const warmupData = flowAPI.controllerConfig.wixCodeApi.window.warmupData;
  const cacheKey = `${compId}_${key}`;
  if (!isSSR) {
    const cache = warmupData.get(cacheKey);
    if (cache) {
      // if onClientFetch was provided, fetch the data from the client even though it exists on the cache, but don't wait for it to complete
      // when it is fetched on the client, call the onClientFetch function with the data
      // This is done to enable forcing client to get most updated data. It is needed for delayed discounts, where the discount only apply at some future date,
      // and we need to get its data after the services data was stored in the cache.
      if (onClientFetch) {
        const clientFetchedDataPromise = callback();
        clientFetchedDataPromise == null || clientFetchedDataPromise.then == null || clientFetchedDataPromise.then(onClientFetch).catch(error => {
          console.error('Error in onClientFetch callback:', error);
        });
        ;
      }
      return cache;
    }
  }
  const data = await callback();
  if (isSSR) {
    warmupData.set(cacheKey, data);
  }
  return data;
}
;
//# sourceMappingURL=manageWarmupData.js.map